/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuccessPatch = {
    properties: {
        text: {
            type: 'any-of',
            contains: [{
                type: 'TranslationCreate',
            }, {
                type: 'null',
            }],
        },
        yearStart: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        yearEnd: {
            type: 'any-of',
            description: `Negative numbers will set the field to null.`,
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        successType: {
            type: 'any-of',
            contains: [{
                type: 'SuccessType',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
